/*
 * Orange angular-swagger-ui - v0.2.7
 *
 * (C) 2015 Orange, all right reserved
 * MIT Licensed
 */

// this module will be created at build phase and will contain swagger-ui HTML template
// this file won't be part of the built JS file
angular.module('swaggerUiTemplates', []);
